var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4970b6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g878"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g655"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.99,20.88c15.97,0,28.96,13.08,28.96,29.12s-12.98,29.12-28.96,29.12c-15.95,0-28.94-13.05-28.94-29.12s12.99-29.12,28.94-29.12ZM74.99,78.93c15.87,0,28.77-12.98,28.77-28.93s-12.9-28.93-28.77-28.93-28.75,12.98-28.75,28.93,12.91,28.93,28.75,28.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path657"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.87,66.57c-3.64,2.76-5.92,3.99-7.51,4.4-3.22-2.72-6.52-6.09-8.67-9.41.47-3.01,1.13-5.89,2-8.65,3.35.81,6.71,1.61,10.09,2.4,1.35,3.77,2.71,7.51,4.08,11.26h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path658"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.35,75.73c-3.19-2.7-2.38-2.58-4.51-5.91,1.2-1.53,7.24-6.63,8.64-9.17,3.16.37,5.68-.09,9.03.71.1,5.02-2.89,8.56-2.78,9.13h0c-2.55,2.02-8.8,4.85-10.38,5.25h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path659"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.74,45.67c-1.12-3.23-1.52-8.62-1.87-12.21,1.2-1.5,8.25-4.04,11.35-4.94,3.92,2.32,6.9,6.26,8.98,9.17-1.69,4.81-4.05,8.18-5.52,10.24-4.3-.74-8.62-1.49-12.93-2.25h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path660"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.37,39.96c.45-2.31-.2-3.94-.67-5.67.14-.09.24-.02.35-.26,4.33,5.89,5.22,14.43,4.82,17.24-.3-.02-.51-.07-.81-.11-.45-4.25-2.09-8.7-3.69-11.2h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path661"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.97,39.64c2.29-6.28,8.18-12.51,11.47-13.88.47.03.86,0,1.25.06-1.65,2.63-1.29,4.92-1.44,5.99-3.41,1.22-6.54,7.3-8.33,9.28-1.02-.22-1.47-.5-2.95-1.45h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path662"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.14,20.98c.47.05,3.78.53,4.18.6,2.96.63,7.6,2.58,8.66,3.59-2.62-1.13-5.25-1.89-6.37-2.31-.69-.06-1.03-.16-2.43.37.02-1.67-5.9-1.97-6.83-2.24.69-.15.96,0,2.78-.02h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path663",
    className: "cls-1",
    d: "M88.56,60.66c.21-3.54-1.35-8.47-3.86-12.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.78,47.92c2.61,4.4,4.1,9.28,3.87,12.74l-.21-.02c.21-3.41-1.27-8.24-3.85-12.6l.18-.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path664",
    className: "cls-1",
    d: "M66.87,66.67c1.44,1.07,7.64,2.59,13.1,3.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.94,66.6c1.45,1.06,7.65,2.55,13.04,3.11v.2c-5.43-.53-11.68-2.05-13.16-3.12l.13-.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path665",
    className: "cls-1",
    d: "M71.77,45.63c-4.05,3.98-6.13,6.13-8.99,9.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.71,45.53l.15.16c-3.91,3.85-6.08,6.07-9.02,9.77l-.17-.13c2.92-3.71,5.11-5.94,9.04-9.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path666",
    className: "cls-1",
    d: "M69.87,33.49c-4.14-1.79-6.92-2.16-10.58-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.87,31.48c2.68,0,5,.59,8.07,1.93l-.1.21c-3.93-1.74-6.69-2.21-10.54-1.77l-.03-.2c.92-.11,1.8-.17,2.61-.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path667",
    className: "cls-1",
    d: "M81.32,28.69c.43-2.71.12-3.87-.06-5.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.37,23.28c.04.25.07.49.1.74.16,1.24.34,2.4-.04,4.67h-.22c.37-2.27.22-3.41.05-4.64-.05-.24-.07-.49-.09-.75l.21-.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path668",
    className: "cls-1",
    d: "M90.12,37.72c7.01-.06,7.74,1.06,9.26,2.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.7,37.6c5.92,0,7.12.94,8.36,1.93.13.1.26.22.41.31l-.14.18c-.15-.1-.28-.2-.41-.31-1.32-1.06-2.46-1.94-8.81-1.89v-.22h.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path669",
    className: "cls-1",
    d: "M97.46,61.35c3.77-3.87,4.64-7.27,5.57-10.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.94,50.97l.21.06c-.08.18-.14.39-.2.6-.87,2.89-1.89,6.17-5.4,9.81l-.16-.16c3.47-3.56,4.48-6.82,5.36-9.72.06-.2.13-.4.19-.59Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path670",
    className: "cls-1",
    d: "M95.12,70.91c-.31-.19-.27-.17-.38-.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.85,70.52v.04q.08.1.27.22l.04.05-.12.17-.06-.05c-.22-.12-.22-.14-.31-.27l-.02-.02.19-.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path671",
    className: "cls-1",
    d: "M65.78,77.42c-3.32-2.22-5.56-5.17-6.4-6.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.48,70.91c.59.9,2.86,4.07,6.36,6.41l-.12.18c-3.53-2.35-5.81-5.54-6.43-6.45l.19-.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path672",
    className: "cls-1",
    d: "M50.96,41.18c0,2.58.47,10.56,1.99,11.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.06,41.18c0,1.47.14,4.09.43,6.36.39,2.96.92,4.76,1.54,5.25l-.13.19c-1.67-1.24-2.05-9.76-2.08-11.8h.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path673",
    className: "cls-1",
    d: "M47.41,59.12c.86,1.32,1.67,1.94,3.28,2.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.5,59.05c.84,1.34,1.69,1.93,3.25,2.31l-.06.21c-1.63-.41-2.48-1-3.38-2.4l.19-.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path674",
    className: "cls-1",
    d: "M73.93,78.85c6.28-.74,8.86-2.09,10.35-3.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.22,75.68l.12.19c-1.58,1.02-4.2,2.33-10.39,3.1l-.03-.21c6.14-.75,8.75-2.02,10.3-3.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path607"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.87,66.57c-3.64,2.76-5.92,3.99-7.51,4.4-3.22-2.72-6.52-6.09-8.67-9.41.47-3.01,1.13-5.89,2-8.65,3.35.81,6.71,1.61,10.09,2.4,1.35,3.77,2.71,7.51,4.08,11.26h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path608"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.35,75.73c-3.19-2.7-2.38-2.58-4.51-5.91,1.2-1.53,7.24-6.63,8.64-9.17,3.16.37,5.68-.09,9.03.71.1,5.02-2.89,8.56-2.78,9.13h0c-2.55,2.02-8.8,4.85-10.38,5.25h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path609"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.74,45.67c-1.12-3.23-1.52-8.62-1.87-12.21,1.2-1.5,8.25-4.04,11.35-4.94,3.92,2.32,6.9,6.26,8.98,9.17-1.69,4.81-4.05,8.18-5.52,10.24-4.3-.74-8.62-1.49-12.93-2.25h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path610"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.37,39.96c.45-2.31-.2-3.94-.67-5.67.14-.09.24-.02.35-.26,4.33,5.89,5.22,14.43,4.82,17.24-.3-.02-.51-.07-.81-.11-.45-4.25-2.09-8.7-3.69-11.2h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path611"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.97,39.64c2.29-6.28,8.18-12.51,11.47-13.88.47.03.86,0,1.25.06-1.65,2.63-1.29,4.92-1.44,5.99-3.41,1.22-6.54,7.3-8.33,9.28-1.02-.22-1.47-.5-2.95-1.45h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path612"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.14,20.98c.47.05,3.78.53,4.18.6,2.96.63,7.6,2.58,8.66,3.59-2.62-1.13-5.25-1.89-6.37-2.31-.69-.06-1.03-.16-2.43.37.02-1.67-5.9-1.97-6.83-2.24.69-.15.96,0,2.78-.02h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.78,47.92c2.61,4.4,4.1,9.28,3.87,12.74l-.21-.02c.21-3.41-1.27-8.24-3.85-12.6l.18-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.94,66.6c1.45,1.06,7.65,2.55,13.04,3.11v.2c-5.43-.53-11.68-2.05-13.16-3.12l.13-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.71,45.53l.15.16c-3.91,3.85-6.08,6.07-9.02,9.77l-.17-.13c2.92-3.71,5.11-5.94,9.04-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.87,31.48c2.68,0,5,.59,8.07,1.93l-.1.21c-3.93-1.74-6.69-2.21-10.54-1.77l-.03-.2c.92-.11,1.8-.17,2.61-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.37,23.28c.04.25.07.49.1.74.16,1.24.34,2.4-.04,4.67h-.22c.37-2.27.22-3.41.05-4.64-.05-.24-.07-.49-.09-.75l.21-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.7,37.6c5.92,0,7.12.94,8.36,1.93.13.1.26.22.41.31l-.14.18c-.15-.1-.28-.2-.41-.31-1.32-1.06-2.46-1.94-8.81-1.89v-.22h.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.94,50.97l.21.06c-.08.18-.14.39-.2.6-.87,2.89-1.89,6.17-5.4,9.81l-.16-.16c3.47-3.56,4.48-6.82,5.36-9.72.06-.2.13-.4.19-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.85,70.52v.04q.08.1.27.22l.04.05-.12.17-.06-.05c-.22-.12-.22-.14-.31-.27l-.02-.02.19-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.48,70.91c.59.9,2.86,4.07,6.36,6.41l-.12.18c-3.53-2.35-5.81-5.54-6.43-6.45l.19-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.06,41.18c0,1.47.14,4.09.43,6.36.39,2.96.92,4.76,1.54,5.25l-.13.19c-1.67-1.24-2.05-9.76-2.08-11.8h.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.5,59.05c.84,1.34,1.69,1.93,3.25,2.31l-.06.21c-1.63-.41-2.48-1-3.38-2.4l.19-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.22,75.68l.12.19c-1.58,1.02-4.2,2.33-10.39,3.1l-.03-.21c6.14-.75,8.75-2.02,10.3-3.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path646"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.93,40.22c-1.46.15-1.89,2.65-2.23,3.52-.93,2.48-1.69,3.03-3.57,2.53-1.81.09-5.43-.58-8.19-1.08-.15-1.14.2-5.25-.1-6.37-.26-.95-1.16.19-1.11-2.73.28.78.78,6.99,1.29,9.13,1.38.75,2.78.57,5.15,1.17,2.31.58,4.98.86,7.34,1.39.72-.55,1.02-1.73,1.7-2.24l1.31-2.94s-.34-2.49-1.6-2.37h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path717"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.7,55.49c-1.98-.64-3.73-.83-5.9-1.37-1.05-.26-2.99-.83-3.95-1.04.56.48,1.71.95,2.04,1.01.45.1,2.8.71,3.23.91,1.28.24,2.12.39,2.99.49.07-.02,1.22,0,1.6,0h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path718"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.75,66.66c-.58-2.29-1.53-4.13-2.39-6.59-.43-1.17-1.08-3.38-1.48-4.48-.21.83.06,2.23.19,2.6.19.47,1.06,3.14,1.11,3.7.62,1.4,1.04,2.31,1.49,3.23.06.04.84,1.17,1.08,1.54h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path719"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.64,62.1c-1.17,1.69-4.51,4.51-6.04,6.05-.56.5-1.03.7-1.55,1.59.56-.34,2.83-2.3,2.98-2.62.21-.37,2.3-2.06,2.62-2.39.61-1.19.9-.47,1.27-1.29.02-.09,1.44-2.24,1.57-2.59l-.86,1.26h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path720"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.45,61.47c-1.32-.32-1.95-.44-3.98-.44-.95-.09-4.06-.19-4.94-.33.5.36,1.55.59,1.85.59.39.02,2.51.26,2.94.37,1.17.05,1.93.05,2.73.02.05-.02,1.09-.18,1.41-.21h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path874"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.76,38.43c2.05-5.37,7.27-10.72,10.18-11.89.42.05.77,0,1.12.07-1.49,2.26-1.15,4.21-1.28,5.13-3.03,1.04-5.81,6.24-7.42,7.9-.88-.17-1.3-.38-2.6-1.21h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path876"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.37,39.96c.45-2.31-.2-3.94-.67-5.67.14-.09.24-.02.35-.26,4.33,5.89,5.22,14.43,4.82,17.24-.3-.02-.51-.07-.81-.11-.45-4.25-2.09-8.7-3.69-11.2h0Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButBleu);
export default __webpack_public_path__ + "static/media/but_bleu.e479f59e1997de76309ead02a3f01d27.svg";
export { ForwardRef as ReactComponent };